import React, { useEffect, useState } from 'react';
import { Rule, getMatchingRules, RULES } from '../../utils/validations/password';
import { RulesContainer, RuleItem, Icon } from './styles';

interface PasswordRulesProps {
  rules?: Rule[];
  value: string;
}

const PasswordRules: React.FC<PasswordRulesProps> = ({ rules = RULES, value = '' }) => {
  const [matchingRules, setMatchingRules] = useState<string[]>([]);

  useEffect(() => {
    const matchedRules = getMatchingRules(value);
    setMatchingRules(matchedRules.map((rule) => rule.message));
  }, [value]);

  return (
    <RulesContainer>
      {rules.map((rule) => (
        <RuleItem key={rule.message} success={matchingRules.includes(rule.message)}>
          <Icon />
          {rule.message}
        </RuleItem>
      ))}
    </RulesContainer>
  );
};

export default PasswordRules;
